import { GetServerSideProps, NextPage } from 'next'
import { PartnerDetailPage } from 'experiences/learn/partners/PartnerDetailPage'
import { getSeoMetaObjectFromPartner } from 'lib/routing/MetaTags'
import { Partner } from 'services/ContentfulService/models/partner/partner'
import { getPartnerBySlug } from 'services/ContentfulService/models/partner/hooks'
import { StandardLayout } from 'shared/layout/StandardLayout'
import { ObjectNotFoundError } from 'services/ContentfulService/errors'

interface Props {
	partner: Partner
}

const PartnerDetails: NextPage<Props> = ({ partner }) => (
	<StandardLayout metaTags={getSeoMetaObjectFromPartner(partner)}>
		<PartnerDetailPage partner={partner} />
	</StandardLayout>
)

export const getServerSideProps: GetServerSideProps<Props> = async ctx => {
	try {
		if (typeof ctx.query.id === 'string') {
			const response = await getPartnerBySlug(ctx.query.id)

			if (response) {
				return {
					props: {
						partner: JSON.parse(JSON.stringify(response))
					}
				}
			}
		}

		throw new ObjectNotFoundError()
	} catch (e) {
		return {
			notFound: true
		}
	}
}

export default PartnerDetails
